export default "__VITE_ASSET__BsqeZufM__"